// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5443 ? "ad7f724d" : chunkId) + "." + __webpack_require__.h() + ".js";
};